import React, { useEffect, useMemo, useRef, useState } from 'react'
import {
  BannerWrapper,
  SlidesContainer,
  Slide,
  Indicators,
  Dot,
} from './Styled'
import { getClickIdFromLink, pushEvent } from '../../../../utils/dataLayer'

const HOSTINGER_URL = 'https://www.hostg.xyz/SHK74'
const HOSTINGER_IMG = 'https://static.meucupom.com/media/2026%20-%20Updates/Clube%20Do%20Aluno/hostinger/'

const hostingerDesktop = {
  id: 'hostinger',
  image: `${HOSTINGER_IMG}hostinger-desktop.jpg`,
  action: 'tracked-redirect',
  href: HOSTINGER_URL,
}

const hostingerMobile = {
  ...hostingerDesktop,
  image: `${HOSTINGER_IMG}hostinger-mobie.jpg`,
}

const isTracked = (banner) => banner.action === 'tracked-redirect'

const bannersClubeDoAluno = [
  hostingerDesktop,
  // {
  //   id: 'dez-do-dez',
  //   image: 'https://static.meucupom.com/media/2026%20-%20Updates/Clube%20Do%20Aluno/10-10/10-10-estacio-desktop.jpg',
  //   scrollTo: 'oferta-do-dia',
  // },
  // {
  //   id: 'google-gemini',
  //   image: 'https://static.meucupom.com/media/2026%20-%20Updates/Clube%20Do%20Aluno/Banner%20gemini.jpg',
  //   href: '',
  // },
  // {
  //   id: 'dell-technologies',
  //   image: 'https://static.meucupom.com/media/2026%20-%20Updates/Clube%20Do%20Aluno/Dell/prod-9433250-mpp-brazil-assets-request-1920x600.jpg',
  //   href: 'https://www.dell.com/pt-br/lp/students',
  // },
  {
    id: 'reserva-estacio',
    image: 'https://static.meucupom.com/media/2026%20-%20Updates/Clube%20Do%20Aluno/design-sem-nome-6.jpg',
    href: 'https://www.reserva.ink/estacio',
  },
  {
    id: 'reserva-wyden',
    image: 'https://static.meucupom.com/media/2026%20-%20Updates/Clube%20Do%20Aluno/design-sem-nome-5.jpg',
    href: 'https://www.reserva.ink/wyden',
  },
]

const bannersClubeDeVantagens = [
  hostingerDesktop,
  // {
  //   id: 'dez-do-dez',
  //   image: 'https://static.meucupom.com/media/2026%20-%20Updates/Clube%20Do%20Aluno/10-10/10-10-estacio-desktop.jpg',
  //   scrollTo: 'oferta-do-dia',
  // },
  // {
  //   id: 'google-gemini',
  //   image: 'https://static.meucupom.com/media/2026%20-%20Updates/Clube%20Do%20Aluno/Banner%20gemini.jpg',
  //   href: '',
  // },
  // {
  //   id: 'dell-technologies',
  //   image: 'https://static.meucupom.com/media/2026%20-%20Updates/Clube%20Do%20Aluno/Dell/prod-9433250-mpp-brazil-assets-request-1920x600.jpg',
  //   href: 'https://www.dell.com/pt-br/lp/students',
  // },
  {
    id: 'reserva-idomed',
    image: 'https://static.meucupom.com/media/2026%20-%20Updates/Clube%20Do%20Aluno/design-sem-nome-3.jpg',
    href: 'https://www.reserva.ink/idomed',
  },
  {
    id: 'reserva-ibmec',
    image: 'https://static.meucupom.com/media/2026%20-%20Updates/Clube%20Do%20Aluno/design-sem-nome-4.jpg',
    href: 'https://www.reserva.ink/ibmec',
  },
]

const bannersClubeDoAlunoMobile = [
  hostingerMobile,

  // {
  //   id: 'dez-do-dez',
  //   image: 'https://static.meucupom.com/media/2026%20-%20Updates/Clube%20Do%20Aluno/10-10/10-10-estacio-mobile.jpg',
  //   scrollTo: 'oferta-do-dia',
  // },
  // {
  //   id: 'google-gemini',
  //   image: 'https://static.meucupom.com/media/2026%20-%20Updates/Clube%20Do%20Aluno/Gemini%20750x500.jpg',
  //   href: '',
  // },
  // {
  //   id: 'dell-technologies',
  //   image: 'https://static.meucupom.com/media/2026%20-%20Updates/Clube%20Do%20Aluno/Dell/prod-9433250-mpp-brazil-assets-request-750x500.jpg',
  //   href: 'https://www.dell.com/pt-br/lp/students',
  // },
  {
    id: 'reserva-estacio',
    image: 'https://static.meucupom.com/media/2026%20-%20Updates/Clube%20Do%20Aluno/mobile/mobile-estacio.jpg',
    href: 'estacio-alunos://meus-beneficios',
  },
  {
    id: 'reserva-wyden',
    image: 'https://static.meucupom.com/media/2026%20-%20Updates/Clube%20Do%20Aluno/mobile/Mobile%20Wyden.jpg',
    href: 'wyden-alunos://meus-beneficios',
  },
]

const bannersClubeDeVantagensMobile = [
  hostingerMobile,
  // {
  //   id: 'dez-do-dez',
  //   image: 'https://static.meucupom.com/media/2026%20-%20Updates/Clube%20Do%20Aluno/10-10/10-10-estacio-mobile.jpg',
  //   scrollTo: 'oferta-do-dia',
  // },
  // {
  //   id: 'google-gemini',
  //   image: 'https://static.meucupom.com/media/2026%20-%20Updates/Clube%20Do%20Aluno/Gemini%20750x500.jpg',
  //   href: '',
  // },
  // {
  //   id: 'dell-technologies',
  //   image: 'https://static.meucupom.com/media/2026%20-%20Updates/Clube%20Do%20Aluno/Dell/prod-9433250-mpp-brazil-assets-request-750x500.jpg',
  //   href: 'https://www.dell.com/pt-br/lp/students',
  // },
  {
    id: 'reserva-idomed',
    image: 'https://static.meucupom.com/media/2026%20-%20Updates/Clube%20Do%20Aluno/mobile/Mobile%20Idomed.jpg',
    href: 'idomed-alunos://meus-beneficios',
  },
  {
    id: 'reserva-ibmec',
    image: 'https://static.meucupom.com/media/2026%20-%20Updates/Clube%20Do%20Aluno/mobile/Mobile%20Ibmec.jpg',
    href: 'ibmec-alunos://meus-beneficios',
  },
]

const Banner = ({
  slug,
  isAuthenticated,
  userId,
  incentiveId,
  getcouponRedirect,
  utmSource,
  utmCampaign,
  showAlert,
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)

  const [current, setCurrent] = useState(0)
  const [dragOffset, setDragOffset] = useState(0)
  const [loadingRedirect, setLoadingRedirect] = useState(false)

  const startX = useRef(0)
  const isDragging = useRef(false)
  const hasMoved = useRef(false)

  const redirectTracked = async (banner) => {
    if (loadingRedirect) return

    const isMobileDevice = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)

    // No desktop a aba é aberta de forma síncrona (dentro do gesto do usuário)
    // para o bloqueador de pop-up não barrar o redirecionamento após o await.
    const popup = isMobileDevice ? null : window.open('', '_blank')

    try {
      setLoadingRedirect(true)

      const trackedLink = await getcouponRedirect({
        link: banner.href,
        source: utmSource,
        campaign: utmCampaign,
        // Visitante sem login também é redirecionado (com tag); só não recebe cashback
        userId: userId ? `${userId}` : undefined,
        store: banner.id,
        incentive: +incentiveId,
      })

      if (!trackedLink) {
        if (popup) popup.close()
        showAlert('Não foi possível ativar a oferta. Tente novamente.', 'error')
        return
      }

      const clickId = getClickIdFromLink(trackedLink)
      if (clickId) pushEvent('click-tracked', { clickId })

      if (isMobileDevice) {
        window.location.assign(trackedLink)
      } else if (popup) {
        popup.opener = null
        popup.location.href = trackedLink
      } else {
        window.location.assign(trackedLink)
      }
    } catch (error) {
      if (popup) popup.close()
      showAlert(`Erro ao ativar a oferta: ${error.message}`, 'error')
    } finally {
      setLoadingRedirect(false)
    }
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const banners = useMemo(() => {
    if (slug === 'clube-do-aluno') {
      return isMobile ? bannersClubeDoAlunoMobile : bannersClubeDoAluno
    }

    if (slug === 'clube-de-vantagens') {
      return isMobile
        ? bannersClubeDeVantagensMobile
        : bannersClubeDeVantagens
    }

    return []
  }, [slug, isMobile])

  useEffect(() => {
    setCurrent(0)
  }, [banners])

  useEffect(() => {
    if (isDragging.current || banners.length === 0) return

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length)
    }, 5000)

    return () => clearInterval(interval)
  }, [banners.length])

  const handleStart = (x) => {
    startX.current = x
    isDragging.current = true
    hasMoved.current = false
  }

  const handleMove = (x) => {
    if (!isDragging.current) return
    const diff = startX.current - x
    if (Math.abs(diff) > 5) hasMoved.current = true
    setDragOffset(diff)
  }

  const handleEnd = () => {
    const threshold = 50

    if (dragOffset > threshold) {
      setCurrent((prev) => (prev + 1) % banners.length)
    } else if (dragOffset < -threshold) {
      setCurrent((prev) => (prev === 0 ? banners.length - 1 : prev - 1))
    }

    setDragOffset(0)
    isDragging.current = false
  }

  if (banners.length === 0) return null

  return (
    <BannerWrapper>
      <SlidesContainer
        current={current}
        dragOffset={dragOffset}
        isDragging={isDragging.current}
        onTouchStart={(e) => handleStart(e.touches[0].clientX)}
        onTouchMove={(e) => handleMove(e.touches[0].clientX)}
        onTouchEnd={handleEnd}
        onMouseDown={(e) => handleStart(e.clientX)}
        onMouseMove={(e) => isDragging.current && handleMove(e.clientX)}
        onMouseUp={handleEnd}
        onMouseLeave={handleEnd}
      >
        {banners.map((banner, index) => (
          <Slide key={index}>
            <a
              href={isTracked(banner) ? '#' : banner.href}
              target={banner.href && !isTracked(banner) ? '_blank' : undefined}
              rel={banner.href && !isTracked(banner) ? 'noopener noreferrer' : undefined}
              role={isTracked(banner) ? 'button' : undefined}
              aria-label={isTracked(banner) ? 'Ativar oferta Hostinger' : undefined}
              onClick={(e) => {
                e.preventDefault()

                // Arrastar o carrossel não deve disparar o clique do banner
                if (hasMoved.current) {
                  hasMoved.current = false
                  return
                }

                window.dataLayer = window.dataLayer || []

                window.dataLayer.push({
                  event: 'banner_click',
                  banner_id: banner.id,
                  banner_slug: slug,
                  banner_url: banner.href || null,
                  banner_logged_in: !!isAuthenticated,
                })

                if (isTracked(banner)) {
                  redirectTracked(banner)
                } else if (banner.scrollTo) {
                  const element = document.getElementById(banner.scrollTo)

                  if (element) {
                    element.scrollIntoView({
                      behavior: 'smooth',
                      block: 'center',
                    })
                  }
                } else if (banner.href) {
                  window.open(banner.href, '_blank')
                }
              }}
            >
              <img
                src={banner.image}
                alt={isTracked(banner) ? 'Hostinger: hospedagem com desconto' : `Banner ${index + 1}`}
                style={isTracked(banner) && loadingRedirect ? { opacity: 0.6 } : undefined}
              />
            </a>
          </Slide>
        ))}
      </SlidesContainer>

      <Indicators>
        {banners.map((_, index) => (
          <Dot
            key={index}
            active={index === current}
            onClick={() => setCurrent(index)}
          />
        ))}
      </Indicators>
    </BannerWrapper>
  )
}

export default Banner